import { render } from "./CategoryTitle.vue?vue&type=template&id=4de6102e&scoped=true"
import script from "./CategoryTitle.vue?vue&type=script&lang=js"
export * from "./CategoryTitle.vue?vue&type=script&lang=js"

import "./CategoryTitle.vue?vue&type=style&index=0&id=4de6102e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de6102e"]])

export default __exports__